/**
 * EEC-051 — tamaño máximo de página que acepta el API (`API_MAX_ROWS_PER_PAGE`
 * en el backend, 250 por defecto). Por encima responde 422.
 *
 * Es el valor que se manda cuando una tabla quiere «todo lo que cuelga de un
 * padre» y pagina en el navegador: los vehículos de una oferta, los costes de
 * un expediente, los apuntes de un movimiento bancario. Ninguno de esos
 * conjuntos se acerca a 250 filas. Lo que sí puede pasar de 250 —costes de la
 * oficina, apuntes, maestros de equipamiento— pagina en servidor con
 * `paginatedOnBack: true` y no usa esta constante.
 */
export const MAX_ROWS_PER_PAGE = 250;
